module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "LINESPACE",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "LINESPACE"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("This book is dedicated to a modern-day man of undaunted courage and perseverance of purpose—")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Battalion Chief Orio Joseph Palmer,")])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("New York City Fire Department,")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("who died on the 78th floor")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("when the South Tower fell")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("on")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("September 11, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("His remains were never found.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0